import { useEffect, useCallback } from "react";
import { useApi, createApiHook } from "../utils/apiUtils";

const useFetchCompleteParticipantApplication = (application, userID) => {
  const { apiGet } = useApi();
  const useApiState = createApiHook(null);
  const { data, error, loading, startLoading, setResponse } = useApiState();

  const fetchData = useCallback(async () => {
    startLoading();
    const response = await apiGet(
      `/aplicaciones/${application}/show_complete_participant_application`,
      "Error al obtener la aplicación del participante",
      { user_id: userID },
    );

    setResponse(response);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [application, userID]);

  useEffect(() => {
    if (application && userID) {
      fetchData();
    }
  }, [fetchData, application, userID]);

  return { data, error, loading, refetch: fetchData };
};

export default useFetchCompleteParticipantApplication;
